/**
 * Firebase codes that mean a popup sign-in was abandoned rather than failing.
 * These are the result of a deliberate user action, so they deserve no error
 * message — just a return to the idle state.
 *
 * `auth/popup-blocked` is deliberately NOT in this set: the user did not choose
 * it and needs to be told to allow popups.
 */
const CANCELLED_POPUP_CODES = new Set([
  'auth/popup-closed-by-user',
  'auth/cancelled-popup-request',
  'auth/user-cancelled',
]);

export function isPopupCancellation(error: unknown): boolean {
  const code = (error as { code?: unknown } | null | undefined)?.code;
  return typeof code === 'string' && CANCELLED_POPUP_CODES.has(code);
}
